const Hide = 'hide';
const Show = 'show';
export class Observer {
  container: HTMLElement;
  onShow?: Function;
  onHide?: Function;
  status = Hide;
  constructor(el: HTMLElement, onShow?: Function, onHide?: Function) {

    this.container = el;
    this.onShow = onShow;
    this.onHide = onHide;
  }
  observe(el: HTMLElement) {
    this.scrollHandle = this.scrollHandle.bind(this, el);
    let elTop = el.offsetTop;
    if(el.offsetParent) {  
      elTop = (el!.offsetParent as HTMLElement).offsetTop
    }
    const elBom = elTop + el.offsetHeight;
    if (this.container.scrollTop > elBom || this.container.scrollTop+this.container.clientHeight <= elTop) {
      this.status = Hide;
      this.onHide && this.onHide();
    } else {
      this.status = Show;
      this.onShow && this.onShow();
    }
    this.container.addEventListener('scroll', this.scrollHandle as any);
  }
  scrollHandle(el: HTMLElement) {

    let elTop = el.offsetTop;
    if(el.offsetParent) {  
      elTop = (el!.offsetParent as HTMLElement).offsetTop
    }
    const elBom = elTop + el.offsetHeight;

    if (this.container.scrollTop > elBom || this.container.scrollTop+this.container.clientHeight <= elTop) {
      this.callHide();
    } else {
      this.callShow();

    }
  }
  callHide() {
    if (this.status !== Hide) {
      this.status = Hide;
      this.onHide && this.onHide();
    }
  }
  callShow() {
    if (this.status !== Show) {
      this.status = Show;
      this.onShow && this.onShow();
    }
  }
  unobserve() {
    this.container.removeEventListener('scroll', this.scrollHandle as any);
  }
}

export default Observer;
